import main2 from './img/main2.png';
import mainRight from './img/main-right.png';
import notebook from './img/notebook.png';
import m1 from './img/m1.png';
import m2 from './img/m2.png';
import o1 from './img/o1.png';
import o2 from './img/o2.png';
import s1 from './img/s1.png';
import s2 from './img/s2.png';
import s3 from './img/s3.png';
import s4 from './img/s4.png';
import s5 from './img/s5.png';
import s6 from './img/s6.png';
import t1 from './img/t1.png';
import t2 from './img/t2.png';
import t3 from './img/t3.png';
import t4 from './img/t4.png';
import t5 from './img/t5.png';
import t6 from './img/t6.png';
import t7 from './img/t7.png';
import t8 from './img/t8.png';
import t9 from './img/t9.png';
import t10 from './img/t10.png';
import t11 from './img/t11.png';
import t12 from './img/t12.png';
import t13 from './img/t13.png';
import t14 from './img/t14.png';

export const images = [
    main2,
    mainRight,
    notebook,
    m1,
    m2,
    o1,
    o2,
    s1,
    s2,
    s3,
    s4,
    s5,
    s6,
    t1,
    t2,
    t3,
    t4,
    t5,
    t6,
    t7,
    t8,
    t9,
    t10,
    t11,
    t12,
    t13,
    t14,
];
